<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->

  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="dark">
            <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          accordion="my-accordion"
          role="tabpanel"
          visible
        >
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">عنوان دقیق دوره: </strong
                  >{{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple"
                    >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                    کرده است؟</strong
                  >
                  <b-form-radio-group
                    v-model="proposal.initialIsSupported"
                    disabled
                  >
                    <b-form-radio :value="true">بله</b-form-radio>
                    <b-form-radio :value="false">خیر</b-form-radio>
                  </b-form-radio-group>
                </li>

                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple">حمایت ها: </strong
                  >{{
                    options.filter(
                      (x) => x.value == proposal.initialSupportedType
                    )[0].text
                  }}
                </li>
                <li
                  v-if="
                    proposal.initialSupportedType == 'other' &&
                    proposal.initialIsSupported
                  "
                >
                  <strong class="c-purple">عنوان حمایت دریافتی: </strong
                  >{{ proposal.initialOtherSupport }}
                </li>
                <li v-if="proposal.initialIsSupported">
                  <strong class="c-purple"> توضیحات حمایت دریافتی: </strong
                  >{{ proposal.initialSupportDescription }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="dark">
            <h5 class="mb-0" style="display: inline-block">
              اطلاعات اصلی دوره
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple"> عنوان به زبان فارسی: </strong
                  >{{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple"> عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li>
                  <strong class="c-purple"> دانشگاه محل اجرای دوره: </strong>
                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.universityId == notUniversity">
                  <strong class="c-purple"> نام دانشگاه: </strong
                  >{{ proposal.otherUniversity }}
                </li>
                <li v-if="proposal.mehvarId != notMehvar">
                  <strong class="c-purple"> محور دوره: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">محور دوره: </strong>سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple"> نام محور: </strong
                  >{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong class="c-purple">ماهیت دوره: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.typeStudy"
                      >مطالعاتی</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="proposal.typeSystemicDevelopmental"
                      >سیستمی و توسعه‌ای</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.typePractical"
                      >کاربردی</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <li>
                  <strong class="c-purple">حوزه دوره: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.zoneMedicine"
                      >پزشکی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneAgriculture"
                      >کشاورزی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneEnvironment"
                      >محیط زیست</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneIndustrial"
                      >صنعتی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneBioComputing"
                      >رایانش زیستی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneOther"
                      >سایر</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <li>
                  <strong class="c-purple"
                    >گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در طی
                    دوره انجام دهید: </strong
                  >{{ proposal.oppurtunityActions }}
                </li>
                <br />
                <div class="custom-table">
                  <b-table
                    :items="proposal.oppurtunityAchievements"
                    :fields="achievmentFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </div>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="light">
            <h5 class="mb-0" style="display: inline-block">اطلاعات متقاضی</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <ul>
                <li>
                  <strong class="c-purple">نام: </strong
                  >{{ proposal.researcherName }}
                </li>
                <li>
                  <strong class="c-purple">نام خانوادگی: </strong
                  >{{ proposal.researcherLastName }}
                </li>
                <li>
                  <strong class="c-purple">کدملی: </strong
                  >{{ proposal.researcherNatCode }}
                </li>
                <li>
                  <strong class="c-purple">تلفن همراه: </strong
                  >{{ proposal.researcherMobile }}
                </li>
                <li>
                  <strong class="c-purple">دورنگار: </strong
                  >{{ proposal.researcherFax }}
                </li>
                <li>
                  <strong class="c-purple">پست الکترونیکی: </strong
                  >{{ proposal.researcherEmail }}
                </li>
                <li>
                  <strong class="c-purple">استان: </strong
                  >{{ proposal.researcherState }}
                </li>
                <li>
                  <strong class="c-purple">شهر: </strong
                  >{{ proposal.researcherCity }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل تحصیل: </strong
                  >{{
                    universities.filter(
                      (x) => x.id == proposal.researcherUniversityId
                    ).length
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.researcherUniversityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityOther }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل اشتغال: </strong>
                  {{
                    proposal.researcherUniversityJobId
                      ? universities.filter(
                          (x) => x.id == proposal.researcherUniversityJobId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0].text
                        : "-"
                      : "-"
                  }}
                </li>
                <li v-if="proposal.researcherUniversityJobId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong
                  >{{ proposal.researcherUniversityJobOther }}
                </li>
                <li>شماره شبا: {{ proposal.researcherIBAN }}</li>
                <li>
                  <strong class="c-purple">نام بانک: </strong
                  >{{ proposal.researcherBankName }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه مقصد: </strong>
                  {{ proposal.researcherUniversityDestination }}
                </li>
                <li>
                  <strong class="c-purple">کشور مقصد: </strong
                  >{{ proposal.researcherCountryDestination }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'master'">
                  <strong class="c-purple">شاخص Hindex استاد: </strong
                  >{{ proposal.researcherHindex }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong class="c-purple">شاخص Hindex دانشجو: </strong
                  >{{ proposal.researcherHindex }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong class="c-purple">نمره امتحان جامع دانشجو: </strong>
                  {{ proposal.researcherComprehensiveTestMark }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong class="c-purple">تاریخ امتحان جامع دانشجو: </strong>
                  {{ proposal.researcherComprehensiveTestDate }}
                </li>
                <li>
                  <strong class="c-purple">عنوان طرح رساله دکتری: </strong>
                  {{ proposal.researcherPhDThesisSubject }}
                </li>
                <li v-if="proposal.researcherMasterStudent == 'student'">
                  <strong class="c-purple">تاریخ تصویب رساله: </strong>
                  {{ proposal.researcherPhDThesisDefenceDate }}
                </li>
                <br />
                <div class="custom-table">
                  <b-table
                    responsive
                    small
                    show-empty
                    stacked="sm"
                    tbody-tr-class="trClass"
                    thead-class="thClass"
                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                    :items="proposal.researcherArticleISI"
                    :fields="articlesFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(upload)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <a
                          v-if="data.item.file.isUploaded"
                          class="btn bc-purple white--text"
                          :href="data.item.uploadedFile.url"
                        >
                          دانلود
                        </a>
                        <p v-else>فایل آپلود نشده است</p>
                      </div>
                    </template>
                  </b-table>
                </div>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="warning">
            <h5 class="mb-0" style="display: inline-block">اطلاعات اساتید</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <p class="h5">استاد راهنمای داخلی</p>
              <ul>
                <div v-if="proposal.supervisors.length">
                  <li>
                    <strong class="c-purple"> نام: </strong
                    >{{ proposal.supervisors[0].name }}
                  </li>
                  <li>
                    <strong class="c-purple"> نام خانوادگی: </strong
                    >{{ proposal.supervisors[0].lastName }}
                  </li>
                  <li>
                    <strong class="c-purple"> کدملی:</strong
                    >{{ proposal.supervisors[0].natCode }}
                  </li>
                  <li>
                    <strong class="c-purple"> تلفن همراه: </strong
                    >{{ proposal.supervisors[0].mobile }}
                  </li>

                  <li>
                    <strong class="c-purple"> پست الکترونیکی: </strong
                    >{{ proposal.supervisors[0].email }}
                  </li>
                  <li>
                    <strong class="c-purple"> سمت: </strong
                    >{{ proposal.supervisors[0].position }}
                  </li>
                  <li>
                    <strong class="c-purple"> دانشگاه محل تحصیل: </strong
                    >{{
                      universities.filter(
                        (x) => x.id == proposal.supervisors[0].universityId
                      ).length
                        ? universities.filter(
                            (x) => x.id == proposal.supervisors[0].universityId
                          )[0]
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityId
                            )[0].text
                          : ""
                        : ""
                    }}
                  </li>
                  <li
                    v-if="proposal.supervisors[0].universityId == notUniversity"
                  >
                    <strong class="c-purple">نام دانشگاه: </strong
                    >{{ proposal.supervisors[0].universityOther }}
                  </li>
                  <li>
                    <strong class="c-purple">دانشگاه محل اشتغال: </strong>
                    {{
                      proposal.supervisors[0].universityJobId
                        ? universities.filter(
                            (x) =>
                              x.id == proposal.supervisors[0].universityJobId
                          )[0]
                          ? universities.filter(
                              (x) =>
                                x.id == proposal.supervisors[0].universityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    v-if="
                      proposal.supervisors[0].universityJobId == notUniversity
                    "
                  >
                    <strong class="c-purple"> نام دانشگاه: </strong
                    >{{ proposal.supervisors[0].universityJobOther }}
                  </li>
                </div>
                <hr />
                <p class="h5">استاد راهنمای خارجی</p>
                <div v-if="proposal.advisors.length">
                  <li>
                    <strong class="c-purple">نام: </strong
                    >{{ proposal.advisors[0].name }}
                  </li>
                  <li>
                    <strong class="c-purple">نام خانوادگی: </strong
                    >{{ proposal.advisors[0].lastName }}
                  </li>
                  <li>
                    <strong class="c-purple">تلفن همراه: </strong
                    >{{ proposal.advisors[0].mobile }}
                  </li>

                  <li>
                    <strong class="c-purple">پست الکترونیکی: </strong
                    >{{ proposal.advisors[0].email }}
                  </li>
                  <li>
                    <strong class="c-purple">سمت: </strong
                    >{{ proposal.advisors[0].position }}
                  </li>
                  <li>
                    <strong class="c-purple">دانشگاه محل تحصیل: </strong
                    >{{ proposal.advisors[0].universityOther }}
                  </li>
                  <li>
                    <strong class="c-purple">آخرین مدرک تحصیلی: </strong
                    >{{ proposal.advisors[0].lastDegree }}
                  </li>
                  <li>
                    <strong class="c-purple">دانشگاه محل اشتغال: </strong
                    >{{ proposal.advisors[0].universityJobOther }}
                  </li>
                </div>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-6 variant="warning">
            <h5 class="mb-0" style="display: inline-block">زمان‌بندی دوره</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="custom-table">
              <b-table
                responsive
                small
                show-empty
                stacked="sm"
                tbody-tr-class="trClass"
                thead-class="thClass"
                empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                :items="proposal.gantData"
                :fields="timeFields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="dark">
            <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              <b-form-group disabled>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                >
                  این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت تاخیر
                  در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dispatchDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </b-form-checkbox>
                <!-- <b-form-checkbox
                :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                v-model="proposal.promiseArrays[1]"
              >
                این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                انجام:
                {{
                  (
                    parseInt(
                      PersonnelCostItem.length == 0
                        ? 0
                        : PersonnelCostItem.map(
                            x =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          ).reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      tripCostItem.length == 0
                        ? 0
                        : tripCostItem
                            .map(x => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      otherCostItem.length == 0
                        ? 0
                        : otherCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      OrgCostItem.length == 0
                        ? 0
                        : OrgCostItem.map(x => x.totalPrice).reduce(
                            (a, b) => parseInt(a) + parseInt(b),
                            0
                          )
                    ) +
                    parseInt(
                      deviceCostItem.length == 0
                        ? 0
                        : deviceCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    )
                  ).toLocaleString()
                }}
                ریال
              </b-form-checkbox> -->
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام و در
                  سایت بارگذاری می‌گردد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >دستاوردهای دوره مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                >
                  بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه شده
                  است.
                  <span v-if="proposal.commercializingType != 'none'">
                    نام بهره‌بردار:
                    <span v-if="proposal.commercializingType == 'company'">{{
                      proposal.companyId == notCompany
                        ? proposal.otherCompanyName
                        : proposal.companyName
                    }}</span>
                    <span v-else>{{
                      proposal.acceleratorId
                        ? accelerators.filter(
                            (x) => x.id == proposal.acceleratorId
                          )[0].text
                        : ""
                    }}</span>
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به ستاد
                  زیست فناوری ارسال و تحویل داده می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.</b-form-checkbox
                >

                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >پروپوزال رساله دکتری اینجانب مصوب شده است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >امتحان جامع با موفقیت سپری شده است</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[10]"
                >
                  میزان شاخص (Hindex) اینجانب صحت دارد</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[11]"
                  >دعوتنامه معتبر از کشور مقصد دریافت شده است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[12] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[12]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    (proposal.researcherName ? proposal.researcherName : "-") +
                    " " +
                    proposal.researcherLastName
                  }}
                  به عنوان متقاضی و اساتید راهنما می‌باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
// NOTE (FUNCTION) to check validation of the email address

import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  name: "Opportunity",
  props: ["proposal", "universities", "mehvars", "companies", "accelerators"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      refereeErrorHandler: false,
      oldData: [],
      expireDisable: false,
      adminToReferee: "",
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: [],
      rejectOptions: [],
      infoo: "",
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      reviewersData: [],
      reviewersFields: [],
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      reviewers: [],
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "underSupervision", text: "درحال بررسی" },
        { id: 3, eng: "inviteReviewers", text: "در دست داوری" },
        { id: 4, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 5, eng: "approve", text: "پذیرش اولیه" },
        { id: 6, eng: "corrected", text: "اصلاح شده" },
        { id: 7, eng: "finalAccept", text: "تایید نهایی" },
        { id: 8, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 9, eng: "reject", text: "رد شده است" },
        { id: 10, eng: "declined", text: "لغو" },
      ],
      selectedReferee: "",
      adminMessage: "",
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      fileItems: [],
      filesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      haveReferee: null,
      contract: null,
      moment: moment,
      ckeckbox: {},
      show: false,
      busy: false,
      pageLoaded: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      colleaguesData: [],
      serviceItems: [],
      selectedColleague: "",
      executor: {},
      rejectMessage: "",
      colleague: {},

      zone: new Array(6).fill(false),
      tabIndex: 0,
      timeFields: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
      ],
      achievitems: [],
      achievFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
        { key: "operation", label: "" },
      ],
      achievFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
      ],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
        { key: "upload", label: "آپلود فایل" },
        { key: "operation", label: "" },
      ],
      articlesFieldsDoc: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
      ],
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      fileFilter: "",
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      file: null,
      OrgCostItem: [],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
      ],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
      ],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        research: { uploadPercentage: 0 },
        industry: { uploadPercentage: 0 },
        agreement: { uploadPercentage: 0 },
        others1: { uploadPercentage: 0 },
        others2: { uploadPercentage: 0 },
        others3: { uploadPercentage: 0 },
      },
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      isLoaded: true,
    };
  },

  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}

.btn-dark {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.card-header {
  background-color: #fff !important;
  border-bottom: none !important;
  padding: 0 !important;
  button {
    padding: 10px 0 !important;
  }
}
.btn-light {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
    font-size: 16px !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
